import { Container } from "./styles";
import logo from "../../assets/logo-sem_fundo.png";
import { db } from "../../server";
import { useNavigate, useParams } from "react-router";
import { useRef, useState } from "react";

export default function FirstLogin() {
	const navigate = useNavigate();
	const passwordInputRef = useRef(null);

	const { userid } = useParams();

	const [oldPassword, setOldPassword] = useState();
	const [newPassword, setNewPassword] = useState();

	async function changePassword({ oldPassword, newPassword }) {
		if (!oldPassword || !newPassword) return alert("Preencha todos os campos.");

		const docRef = db.collection("usuarios");

		if (newPassword === oldPassword) {
			return alert("As senhas não podem ser iguais!");
		}
		let tempPassword;

		await docRef.get().then((doc) => {
			doc.forEach((doc) => {
				tempPassword = doc.data().password;
			});
		});

		if (tempPassword !== oldPassword) {
			return alert("a senha antiga esta diferente atual");
		}

		if (tempPassword === newPassword) {
			return alert("a nova senha deve ser diferente da antiga!");
		}

		docRef.doc(userid).update({ password: newPassword, firstAccess: false });
		navigate("/login");
	}

	return (
		<div>
			<Container>
				<div className="header">
					<img src={logo} alt="logo" />
					<h1>Defina uma senha</h1>
				</div>

				<div className="input-cover">
					<div className="input-wrapper">
						<label htmlFor="oldPassword">Senha antiga</label>
						<input
							type="password"
							name="oldPassword"
							id="oldPassword"
							placeholder="senha anterior"
							value={oldPassword}
							onChange={(e) => setOldPassword(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
									passwordInputRef.current?.focus();
								}
							}}
						/>
					</div>
					<div className="input-wrapper">
						<label htmlFor="newPassword">Nova senha</label>
						<input
							type="newPassword"
							name="newPassword"
							id="newPassword"
							ref={passwordInputRef}
							placeholder="Senha"
							value={newPassword}
							onChange={(e) => setNewPassword(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter")
									changePassword({ oldPassword, newPassword });
							}}
						/>
					</div>
				</div>

				<button onClick={() => changePassword({ oldPassword, newPassword })}>
					Salvar
				</button>
			</Container>
		</div>
	);
}
